import React, { useState, useContext, useEffect } from "react";
import { showInfoToast } from "../../validation/ToastContainer";
import { getConfirmPopup } from "../../view/popup/PopupContainer";
import { PopupContext } from "../../index"
import { getIdleTimeoutPeriod, saveIdleTimeoutPeriod } from "./systemSettingsService";
import { ChevronDown } from 'lucide-react';



export default function IdleTimeoutSection() {

  const { setPopup } = useContext(PopupContext);
  const [idlePeriod, setIdleTimeoutPeriod] = useState('0');
  const [collapsed, setCollapsed] = useState(true);

  // const setPeriod = false;
  const isStartDisabled = false;

  const fetchData = async () => {
    try {
      const idleTimeoutData = await getIdleTimeoutPeriod();
      setIdleTimeoutPeriod(idleTimeoutData.value);
    } catch (error) {
      console.error('Error:', error);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);


  const onSetIdleTimoutPeriodClick = event => {
    showInfoToast('Setting Idle Timeout Period', 'Idle Timeout Period');
    // setPeriod(true);

    setPopup(
      getConfirmPopup('Are you sure?',
        'Octopus VAR Idle Timeout Period',
        () => onConfirm()
      )
    );

    const onConfirm = async () => {
      await saveIdleTimeoutPeriod(idlePeriod);
    };
  };

  const changeIdleTimeoutPeriod = (value) => { setIdleTimeoutPeriod(value); }

  return (
    <>
      <button
        className="oct_settings-section-header"
        onClick={() => setCollapsed(!collapsed)}
      >
        <h3>Idle Timeout Period</h3>
        <ChevronDown className={`oct_icon oct_settings-chevron-v2 ${!collapsed ? 'oct_expanded' : ''}`}/>
      </button>

      <div className={`oct_settings-section-body ${collapsed ? 'oct_collapsed' : 'oct_expanded'}`}>
        <p className="oct_settings-description">
          Idle Timeout Period is the maximum length of time the user can stay logged in when no action is happening on the App UI.
        </p>

        <div className="oct_settings-form-grid">
          <div className="oct_settings-field">
            <label className="oct_settings-label">Idle-Time</label>
            <input
              className="oct_settings-input-v2"
              type="number"
              value={idlePeriod}
              onChange={event => changeIdleTimeoutPeriod(event.target.value)}
            />
          </div>
          <div className="oct_settings-field">
            <label className="oct_settings-label">Unit</label>
            <select className="oct_select-v2" disabled>
              <option value="mins">mins</option>
            </select>
          </div>
        </div>

        <button
          className={`oct_settings-btn-v2 ${isStartDisabled ? 'disabled' : ''}`}
          onClick={onSetIdleTimoutPeriodClick}
        >
          Save Idle-Time
        </button>
      </div>
    </>
  );
}
